<div class="db-optimize-images" [ngClass]="{'loading': (loading && !pageLayout)}">
  <div class="db-optimize-images-blocks">
  <div class="db-optimize-images__header mb20">
    <div>
      <h3 [innerHTML]="'text_ioOptimizerTitle' | dbText"></h3>
      <p [innerHTML]="'text_ioOptimizerDesc' | dbText"></p>
    </div>
  </div>

  <div class="db-optimize-images__content mb25">
    <div class="db-optimize-images__images" [ngClass]="{'db-ready-to-optimize': stats?.notCompressed}">
      <div class="db-optimize-images__block {{!optimizeImagesStats}}"
           [ngClass]="{'ds-lazy-load': !optimizeImagesStats && !pageLayout}">
        <div class="db-optimize-images__ready-optimize"
             [ngClass]="{'all-optimize': !loading && !stats?.notCompressed && !stats?.notCompressedFull}">
          <i class="db-icon db-icon-info-lined" [dsTooltip]="'text_speedOptimizerTooltip' | dbText"
             dsTooltipPosition="bottom" dsTooltipAlign="right"></i>
          <div>
            <div class="db-ready-optimize" *ngIf="stats?.notCompressed">
              <div class="ds-notification-success small mb10">
                <div>
                  <i class="db-icon db-icon-ds-checkmark-bg"></i>
                  <span class="semibold">{{ 'text_optimized' | dbText }}</span>
                </div>
              </div>
              <p class="db-optimize-images__ready-optimize-title mb12"
                 [innerHTML]="'text_ioOptimizerImagesCount' | dbText : {count: stats?.compressedFull + stats?.compressedThumbs + stats?.compressedOther, full: stats?.compressedFull}">
              </p>
              <p class="db-optimize-images__ready-optimize-desc mb20"
                 [innerHTML]="'text_ioOptimizerImagesReady' | dbText">
              </p>
            </div>
            <div class="db-optimize-images__all-optimized">
              <i class="db-icon db-icon-ds-circle-filled"
                 *ngIf="!loading && !stats?.notCompressed && stats?.compressedFull"></i>
            </div>

            <p class="db-optimize-images__ready-optimize-title" *ngIf="!stats?.notCompressed &&
            !stats?.compressedFull"
               [innerHTML]="'text_speedOptimizerImagesCount' | dbText : {count: stats?.notCompressed || 0}">
            </p>

            <p class="db-optimize-images__ready-optimize-desc all-optimized"
               *ngIf="!stats?.notCompressed && !stats?.compressedFull"
               [innerHTML]="'text_ioOptimizerNoImages' | dbText : {count: stats?.compressedFull + stats?.compressedThumbs + stats?.compressedOther, full: stats?.compressedFull}">
            </p>

            <p class="db-optimize-images__ready-optimize-text" *ngIf="!stats?.notCompressed && !stats?.compressedFull">
              <span>{{'text_optimizerNoImagesForOptimize' | dbText}}</span>
            </p>

            <p class="db-optimize-images__ready-optimize-text"
               *ngIf="!stats?.notCompressed && stats?.compressedFull">
              <span>{{'text_ioOptimizerAllSet' | dbText}}</span>
            </p>

            <p class="db-optimize-images__ready-optimize-desc"
               *ngIf="!stats?.notCompressed && stats?.compressedFull"
               [innerHTML]="'text_ioOptimizerImagesAllOptimized' | dbText : {count: stats?.compressedFull + stats?.compressedThumbs + stats?.compressedOther, full: stats?.compressedFull}">
            </p>

          </div>
        </div>
      </div>

      <div class="db-optimize-images__block" *ngIf="((!stats?.notCompressed && !stats?.compressedFull) ||
      (stats?.compressedFull && !stats?.notCompressed && !stats?.notCompressedFull))"
           [ngClass]="{'ds-lazy-load':
      !optimizeImagesStats && !pageLayout}">
        <div class="pb20">
          <div>
            <p class="db-optimize-images__block-title" [innerHTML]="((stats?.lastCompressedSize) | size: {unit: 'B'}) +
            ' (' + (stats?.lastCompressedPercent | roundNumber) + '%)'"></p>
            <span class="db-optimize-images__block-desc">{{'text_lastOptimization' | dbText}}</span>
          </div>
        </div>
        <div class="pb20">
          <div>
            <p class="db-optimize-images__block-title"
               [innerHTML]="((stats?.reducedSize) | size: {unit: 'B'}) + ' (' + (stats?.reducedPercent | roundNumber) + '%)'"></p>
            <span class="db-optimize-images__block-desc">{{'text_total' | dbText}}</span>
          </div>
        </div>
        <a class="ds-btn-green"
           [ngClass]="{'ds-btn-disabled': loading || (!loading && !stats?.notCompressed && !stats?.notCompressedFull) || stats?.usedCountFromLimit >= stats?.planLimit}"
           (click)="optimizeImages()">
          <span *ngIf="!loading">Optimize</span>
          <span class="ds-spinner-circle" *ngIf="loading"></span>
        </a>
      </div>
      <div class="db-optimize-images__block not-compressed" [ngClass]="{'ds-lazy-load':
      !optimizeImagesStats && !pageLayout}" *ngIf="stats?.notCompressed">
        <div>
          <div class="ds-notification-error small mb10">
            <div>
              <i class="db-icon db-icon-ds-close-bg"></i>
              <span class="semibold">Not optimized</span>
            </div>
          </div>
          <p class="db-optimize-images__ready-optimize-title mb12"
             [innerHTML]="'text_ioOptimizerImagesCount' | dbText : {count: stats?.notCompressed || 0}">
          </p>
          <p class="db-optimize-images__ready-optimize-desc"
             [innerHTML]="'text_ioOptimizerReadyToOptimizeDesc' | dbText">
          </p>
        </div>

        <div class="db-ready-optimize-footer mt30">
          <div>
            <p><b>Total size:</b>
            <p [innerHTML]="stats?.notCompressedSize | size: {unit: 'B'}"></p>
          </div>

          <a class="ds-btn-green ds-btn-m"
             [ngClass]="{'ds-btn-disabled': loading || (!loading && !stats?.notCompressed && !stats?.notCompressedFull) || stats?.usedCountFromLimit >= stats?.planLimit}"
             (click)="optimizeImages()">
            <span *ngIf="!loading">Optimize</span>
            <span class="ds-spinner-circle" *ngIf="loading"></span>
          </a>
        </div>
    </div>
  </div>

</div>

  <div class="ds-notification-warning ds-notification-error mb20"
       *ngIf="!!optimizationError">
    <div>
      <i class="db-icon db-icon-ds-info-bg"></i>
      <p>
        <b>Something Went Wrong. </b> An Error occurred while optimizing images, please <a class="text-underline" (click)="onClick.emit()">contact us.</a>
      </p>
    </div>
  </div>
  <hr class="separator" *ngIf="!!optimizedImages?.length">

  </div>

  <div class="db-optimized-images mt20" *ngIf="!!optimizedImages?.length" [ngClass]="{'ds-lazy-load': optimizedPagesLoading}">
    <div>
      <div class="db-optimized-images-header">
        <p>Last optimization</p>
        <p>Image count</p>
        <p>Image size</p>
      </div>
      <div class="db-optimized-images-list" [ngClass]="{'ds-lazy-load': optimizedPagesLoading, 'db-withScroll': optimizedImages?.length > 6}">
        <div class="db-optimized-images-list-item"
             *ngFor="let page of optimizedImages; let index = index">
          <p [innerHTML]="page?.date ? (page?.date | date) : 'Just now'"></p>
          <p [innerHTML]="page?.imagesCount + ' (' + page?.imagesMode + ')'"></p>
          <p [innerHTML]="page?.imagesSize | size: {unit: 'B'}"></p>
        </div>
      </div>
    </div>
  </div>
</div>
